<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="className"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4 6.25C4 7.49264 5.00736 8.5 6.25 8.5C7.49264 8.5 8.5 7.49264 8.5 6.25C8.5 5.00736 7.49264 4 6.25 4C5.00736 4 4 5.00736 4 6.25Z"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4 13.75C4 14.9927 5.00736 16 6.25 16C7.49264 16 8.5 14.9927 8.5 13.75C8.5 12.5073 7.49264 11.5 6.25 11.5C5.00736 11.5 4 12.5073 4 13.75Z"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.5 6.25C11.5 7.49264 12.5073 8.5 13.75 8.5C14.9927 8.5 16 7.49264 16 6.25C16 5.00736 14.9927 4 13.75 4C12.5073 4 11.5 5.00736 11.5 6.25Z"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.5 13.75C11.5 14.9927 12.5073 16 13.75 16C14.9927 16 16 14.9927 16 13.75C16 12.5073 14.9927 11.5 13.75 11.5C12.5073 11.5 11.5 12.5073 11.5 13.75Z"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'AppGameWorkIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>
